import pathRoutes from "../../../routes/pathRoutes";
import { useReport } from "./useReport";
import { Edit, Remove, View } from "@app/components/Actions";
import { CircularProgress, IconButton } from "@mui/material";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { configButtonsConditioning } from "./constants";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ActionMenu from "@app/components/ActionMenu";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import SendIcon from "@mui/icons-material/Send";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const getTitleByTypeReport = (typeReport) => {
  for (const key in configButtonsConditioning) {
    if (configButtonsConditioning[key].type === typeReport) {
      return configButtonsConditioning[key].title;
    }
  }
  return null;
};

export const columnsReport = (
  handleAnexar,
  handleGenerate,
  handleEditar,
  handleSendMail
) => [
  {
    field: "ref_report",
    headerName: "Referencia Informe",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <div>{`${params.row.ref_report}${
        params.row.results_consecutive !== null
          ? `/${params.row.results_consecutive}`
          : ""
      }`}</div>
    ),
  },
  {
    field: "type",
    headerName: "Tipo Informe",
    headerAlign: "center",
    align: "center",
    flex: 2,
    renderCell: (params: any) => (
      <div>{getTitleByTypeReport(params.row.type)}</div>
    ),
  },
  {
    field: "emission_date",
    headerName: "Fecha Emisión",
    width: 150,
    headerAlign: "center",
    align: "center",

    renderCell: (params: any) => (
      <div>{new Date(params.row.emission_date).toLocaleDateString()}</div>
    ),
  },
  {
    field: "client",
    headerName: "Cliente",
    width: 150,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => <div>{params.row.client?.entidad}</div>,
  },
  {
    field: "installation",
    headerName: "Instalación",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params: any) => <div>{params.row.installation?.codigo}</div>,
  },
  {
    field: "motivo_muestreo_id",
    headerName: "Motivo",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params: any) => (
      <div>{params.row.motivo_muestreo_id?.codigo}</div>
    ),
  },
  {
    field: "anexo_2",
    headerName: "Anexos",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params: any) => (
      <div>
        {params.row.anexo_1 || params.row.anexo_2 || params.row.anexo_3
          ? "Si"
          : "No"}
      </div>
    ),
  },
  {
    field: "letter",
    headerName: "Carta",
    headerAlign: "center",
    align: "center",
    renderCell: (params: any) => <div>{params.row.letter ? "Si" : "No"}</div>,
  },
  {
    field: "fecha_entrega",
    headerName: "Fecha Entrega",
    headerAlign: "center",
    align: "center",
    renderCell: (params: any) => (
      <div>
        {params.row.fecha_entrega
          ? new Date(params.row.fecha_entrega).toLocaleDateString()
          : ""}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 2,
    renderCell: (params: any) => (
      <ActionMenu
        actions={[
          <View to={`${pathRoutes.ADMIN_INFORMES}/ver/${params.id}`} />,
          params.row.es_ultimo_hijo !== false ? (
            params.row.type === "results" &&
            params.row.fecha_entrega !== null ? (
              <IconButton
                onClick={() => handleEditar(params.row)}
                title="Editar"
              >
                <EditOutlinedIcon color="secondary" />
              </IconButton>
            ) : (
              <PermissionComponentGate
                permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
              >
                <Edit to={`${pathRoutes.ADMIN_INFORMES}/editar/${params.id}`} />
              </PermissionComponentGate>
            )
          ) : (
            false
          ),
          params.row.type === "results" &&
          params.row.es_ultimo_hijo !== false &&
          params.row.fecha_entrega === null ? (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton
                aria-label="Anexar"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAnexar(params.row);
                }}
                color="info"
                title="Anexar"
              >
                <AttachFileOutlinedIcon color="info" sx={{ color: "black" }} />
              </IconButton>
            </PermissionComponentGate>
          ) : (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton aria-label="Anexar" color="inherit" title="Anexar">
                <AttachFileOutlinedIcon
                  color="inherit"
                  sx={{ color: "grey", cursor: "not-allowed" }}
                />
              </IconButton>
            </PermissionComponentGate>
          ),
          params.row.type === "results" &&
          params.row.es_ultimo_hijo !== false &&
          params.row.fecha_entrega === null ? (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton
                aria-label="Generar"
                onClick={(e) => {
                  e.stopPropagation();
                  handleGenerate(params.row);
                }}
                color="info"
                title="Generar"
              >
                {useReport.getState().loadingDownload ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <InsertDriveFileOutlinedIcon
                    color="info"
                    sx={{ color: "black" }}
                  />
                )}
              </IconButton>
            </PermissionComponentGate>
          ) : (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton aria-label="Anexar" color="inherit" title="Anexar">
                <InsertDriveFileOutlinedIcon
                  color="inherit"
                  sx={{ color: "grey", cursor: "not-allowed" }}
                />
              </IconButton>
            </PermissionComponentGate>
          ),
          params.row.fecha_entrega === null ? (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <Remove
                onRemove={() => useReport.getState().remove(params.row.id)}
                title="Va a borrar de forma permanente este informe"
                text="¿quiere continuar?"
              />
            </PermissionComponentGate>
          ) : (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton aria-label="Anexar" color="inherit" title="Anexar">
                <DeleteOutlinedIcon
                  color="inherit"
                  sx={{ color: "grey", cursor: "not-allowed" }}
                />
              </IconButton>
            </PermissionComponentGate>
          ),
          params.row.type === "results" ? (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton
                aria-label="Generar"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSendMail(params.row);
                }}
                color="info"
                title="Generar"
              >
                <SendIcon color="info" sx={{ color: "black" }} />
              </IconButton>
            </PermissionComponentGate>
          ) : (
            <PermissionComponentGate
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <IconButton aria-label="Anexar" color="inherit" title="Anexar">
                <SendIcon
                  color="inherit"
                  sx={{ color: "grey", cursor: "not-allowed" }}
                />
              </IconButton>
            </PermissionComponentGate>
          ),
          ,
        ].filter(Boolean)}
      />
    ),
  },
];
